import { connect } from 'react-redux';

import { MODULE_NAME } from 'src/constants';

import { getAppName, getIsMobile } from 'src/store/view/selectors';
import {
  getHeaderBannerData,
  getIsHeaderBannerAvailable,
} from 'src/store/headerBanner/selectors';

import { isMapView as isMapExpandedSeoSelector } from 'src/routes/SeoApp/domain/state/map/selectors';
import { isExpandedMapSelector as isMapExpandedSearchSelector } from 'src/routes/SearchPage/store/map/selectors';

import { HeaderBanner } from './HeaderBanner';

const mapStateToProps = (state) => ({
  bannerData: getHeaderBannerData(state),
  isMobile: getIsMobile(state),
  isAvailable: getIsHeaderBannerAvailable(state),
  isMapExpanded:
    (getAppName(state) === MODULE_NAME.SEO &&
      isMapExpandedSeoSelector(state)) ||
    (getAppName(state) === MODULE_NAME.SEARCH &&
      isMapExpandedSearchSelector(state)),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ReturnType<typeof mapStateToProps>;

export default connector(HeaderBanner);
